if (!customElements.get("custom-form")) {
    class CustomForm extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector("form");
            this.form.addEventListener("submit", this.submitForm.bind(this));
            this.submitButton = this.form.querySelector('[type="submit"]');
            this.fetchUrl = this.getAttribute("fetch-url");
            this.successAlert = this.querySelector(".bg-success-bg");
            this.errorAlert = this.querySelector(".bg-error-bg");
        }

        async submitForm(e) {
            e.preventDefault();
            const formData = new FormData(this.form);
            const fetchRequestOpts = {
                method: "POST",
                headers: {
                    Accept: "application/javascript",
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: formData,
            };

            try {
                this.submitButton.classList.add("is-loading");
                this.submitButton.setAttribute("aria-disabled", "true");
                const response = await fetch(this.fetchUrl, fetchRequestOpts);
                const data = await response.json();
                if (data?.code === 2000) {
                    this.successAlert.classList.remove("hidden");
                    this.submitButton.classList.add("is-success");
                    this.form.reset();
                } else {
                    this.errorAlert.innerHTML =
                        data?.message || "Something went wrong";
                    this.errorAlert.classList.remove("hidden");
                }
            } catch (error) {
                console.log(error);
                this.errorAlert.innerHTML = "Something went wrong";
                this.errorAlert.classList.remove("hidden");
            } finally {
                this.submitButton.classList.remove("is-loading");
                this.submitButton.removeAttribute("aria-disabled");
                setTimeout(() => {
                    this.submitButton.classList.remove("is-loading");
                    this.submitButton.classList.remove("is-success");
                }, 1400);
            }
        }
    }

    customElements.define("custom-form", CustomForm);
}
